"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bevelPanel2 = exports.bevelPanelOutline = exports.bevelPanelBackground = exports.bevelPanel = exports.bevelAreaR = exports.bevelArea = exports.createGraphics = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
function createGraphics(layer) {
    var g = common_sidecar_1.common.getPhaserScene().add.graphics();
    layer.add(g);
    return g;
}
exports.createGraphics = createGraphics;
function bevelArea(g, x, y, w, h, bevel, inset) {
    if (bevel === void 0) { bevel = 16; }
    if (inset === void 0) { inset = 0; }
    x += inset;
    y += inset;
    w -= inset * 2;
    h -= inset * 2;
    g.beginPath();
    g.moveTo(x, y);
    g.lineTo(x + w - bevel, y);
    g.lineTo(x + w, y + bevel);
    g.lineTo(x + w, y + h);
    g.lineTo(x + bevel, y + h);
    g.lineTo(x, y + h - bevel);
    g.closePath();
}
exports.bevelArea = bevelArea;
function bevelAreaR(g, x, y, w, h, bevel, inset) {
    if (inset === void 0) { inset = 0; }
    x += inset;
    y += inset;
    w -= inset * 2;
    h -= inset * 2;
    g.beginPath();
    g.moveTo(x, y + bevel);
    g.lineTo(x + bevel, y);
    g.lineTo(x + w, y);
    g.lineTo(x + w, y + h - bevel);
    g.lineTo(x + w - bevel, y + h);
    g.lineTo(x, y + h);
    g.closePath();
}
exports.bevelAreaR = bevelAreaR;
function bevelPanel(g, x, y, w, h, bevel, inset) {
    if (bevel === void 0) { bevel = 16; }
    if (inset === void 0) { inset = 10; }
    bevelPanelBackground(g, x, y, w, h, bevel, inset);
    bevelPanelOutline(g, x, y, w, h, bevel, inset);
}
exports.bevelPanel = bevelPanel;
function bevelPanelBackground(g, x, y, w, h, bevel, inset) {
    if (bevel === void 0) { bevel = 16; }
    if (inset === void 0) { inset = 10; }
    g.fillStyle(voyageColors_sidecar_1.voyageColors.purpleDull, 1);
    bevelArea(g, x, y, w, h, bevel);
    g.fill();
}
exports.bevelPanelBackground = bevelPanelBackground;
function bevelPanelOutline(g, x, y, w, h, bevel, inset) {
    if (bevel === void 0) { bevel = 16; }
    if (inset === void 0) { inset = 10; }
    g.lineStyle(6, voyageColors_sidecar_1.voyageColors.g3);
    bevelArea(g, x, y, w, h, bevel, inset);
    g.stroke();
}
exports.bevelPanelOutline = bevelPanelOutline;
function bevelPanel2(g, x, y, w, h, bevel, inset) {
    if (bevel === void 0) { bevel = 16; }
    if (inset === void 0) { inset = 10; }
    g.fillStyle(voyageColors_sidecar_1.voyageColors.g3, 1);
    bevelArea(g, x, y, w, h, bevel);
    g.fill();
    g.fillStyle(voyageColors_sidecar_1.voyageColors.purpleDull, 1);
    bevelArea(g, x, y, w, h, bevel, 6);
    g.fill();
}
exports.bevelPanel2 = bevelPanel2;
